/* eslint-disable jsx-a11y/no-autofocus */
/* eslint-disable no-nested-ternary */
import React, { forwardRef, useRef, useState } from 'react';
import classNames from 'classnames';
import { ButtonSize } from 'components/UI_kit_3/Button/Button';
import { ReactComponent as EyeIcon } from 'assets/icons_3/eye.svg';
import FormLabel from 'components/UI_kit_3/FormLabel/FormLabel';
import style from './FormText.module.scss';

export interface IFormTextProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'size'> {
  isValid?: boolean;
  isInvalid?: boolean;
  error?: string | boolean | Array<string> | null;
  size?: ButtonSize;
  length?: number;
  label?: string;
  hint?: string;
  requested?: boolean;
  onClear?: () => void;
  textCenter?: boolean
  suffix?:string;
  qaElement?:string;
  qaElementSuffix?:string;
  qaElementFeedback?:string;
  Icon?: React.FunctionComponent<
  React.SVGProps<SVGSVGElement> & {
    title?: string | undefined;
  }
  >;
}

const FormText = forwardRef<HTMLInputElement, IFormTextProps>(({
  className,
  isValid,
  Icon,
  isInvalid,
  label,
  hint,
  error,
  type,
  required,
  size = 'md',
  length,
  textCenter,
  onClear,
  suffix,
  qaElementSuffix,
  qaElement,
  qaElementFeedback,
  ...props
}, ref) => {
  const handleClear = () => {
    if (onClear) onClear();
  };
  const eyeRef = useRef(null);
  const [showPass, setShowPass] = useState(type !== 'password');

  return (
    <div
      className={classNames(className, style.formText, {
        [style.invalid]: isInvalid,
        [style.valid]: isValid,
        [style.hasIcon]: !!Icon,
        [style[`size-${size}`]]: !!size,
      })}
    >
      {label && (
        <FormLabel required={required} htmlFor={props.id}>
          {label}
        </FormLabel>
      )}
      <div className={style.inputWrapper}>
        {Icon && <Icon className={style.icon} />}
        <input
          className={classNames(style.input, {
            [style.textCenter]: textCenter,
          })}
          ref={ref}
          size={length}
          qa-element={qaElement}
          type={type === 'password' ? showPass ? 'text' : 'password' : type}
          {...props}
          autoFocus={props.autoFocus}
        />
        {onClear && (
        <button type="button" className={style.clear} aria-label="clear" onClick={handleClear}>
          clear
        </button>
        )}
        {type === 'password' && (
          <EyeIcon
            ref={eyeRef}
            className={style.eyeIcon}
            onMouseEnter={() => setShowPass(true)}
            onMouseLeave={() => setShowPass(false)}
          />
        )}
        {suffix && (
        <span
          className={style.suffix}
          qa-element={qaElementSuffix}
        >
          {suffix}
        </span>
        )}
      </div>
      {hint && <div className={classNames(style.hint)}>{hint}</div>}
      {Array.isArray(error) && error.map((errMsg, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <div key={index} className={classNames(style.error)}>{errMsg}</div>
      ))}
      {error && !Array.isArray(error) && isInvalid
      && <div className={classNames(style.error)} qa-element={qaElementFeedback}>{error}</div>}
    </div>
  );
});
export default FormText;
